<div class="investment page-sub-section">
   <div class="contentBox investors-sec">
<!--      <div class="investors public">-->
<!--         <div class="font-18 proximaNovaSb margin-b-30 wow fadeInUp"-->
<!--              data-wow-duration="500ms" data-wow-delay="50ms">Public Equities</div>-->
<!--         <ul class="investors-list">-->
<!--            <li>-->
<!--               <div class=" investor-icon wow fadeInUp"-->
<!--                    data-wow-duration="500ms" data-wow-delay="150ms">-->
<!--                  <img src="assets/images/sale-force.png" alt="">-->
<!--               </div>-->
<!--               <div class=" wow fadeInUp"-->
<!--                    data-wow-duration="500ms" data-wow-delay="150ms">Salesforce</div>-->
<!--            </li>-->
<!--            <li>-->
<!--               <div class=" investor-icon wow fadeInUp"-->
<!--                    data-wow-duration="500ms" data-wow-delay="150ms">-->
<!--                  <img src="assets/images/king-burger.png" alt="">-->
<!--               </div>-->
<!--               <div class=" wow fadeInUp"-->
<!--                    data-wow-duration="500ms" data-wow-delay="150ms">Burger King</div>-->
<!--            </li>-->
<!--            <li>-->
<!--               <div class="height-35 investor-icon wow fadeInUp"-->
<!--                    data-wow-duration="500ms" data-wow-delay="150ms">-->
<!--                  <img src="assets/images/thermo-fisher.png" alt="">-->
<!--               </div>-->
<!--               <div class=" wow fadeInUp"-->
<!--                    data-wow-duration="500ms" data-wow-delay="150ms">Thermo Fisher</div>-->
<!--            </li>-->
<!--         </ul>-->
<!--      </div>-->
      <div class="investors private font-17">
         <div class="font-18 proximaNovaSb margin-b-50 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="50ms">Private Companies</div>
         <ul class="investors-list">
            <li>
               <div class="height-40 investor-icon wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  <img src="assets/images/demica.png" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">Demica</div>
            </li>
            <li>
               <div class="height-50 investor-icon nse wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  <img src="assets/images/nse.png" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">NSE</div>
            </li>
            <li>
               <div class="investor-icon wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">
                  <img src="assets/images/cinnamon.png" alt="">
               </div>
               <div class=" wow fadeInUp"
                    data-wow-duration="500ms" data-wow-delay="150ms">Cinnamon</div>
            </li>
         </ul>
      </div>
   </div>
</div>
